import React from 'react';

import {requestEditorURL} from 'requests/RequestDAO';
import {apiIdToIconName} from 'util/APIUtil';

import {getSharedSmartChipProps, SharedSmartChipProps} from './ChipUtil';
import SmartChip from './SmartChip';
import useSmartChipQuery, {SmartChipType} from './useSmartChipQuery';

export default function RequestChip(props: SharedSmartChipProps<SmartChipType.REQUEST>): JSX.Element {
  const sharedSmartChipProps = getSharedSmartChipProps(props);
  const {id, onClick} = sharedSmartChipProps;

  const {
    item: request,
    handleClickLink,
    isInaccessible,
    itemUrl: requestUrl,
  } = useSmartChipQuery<SmartChipType.REQUEST>({
    id,
    onClick,
    getUrlFn: (request) => requestEditorURL(request.id),
  });

  return (
    <SmartChip
      {...sharedSmartChipProps}
      icon={request != null ? apiIdToIconName(request.id) : null}
      isInaccessible={isInaccessible}
      item={request}
      onClick={handleClickLink}
      url={requestUrl}
    />
  );
}
